<template>
  <v-list-item two-line :class="miniVariant && 'px-0'">
    <v-list-item-icon>
      <v-icon>mdi-account</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ getName() }}</v-list-item-title>
      <v-list-item-subtitle>{{ getRole() }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'account',

  data: () => ({
    miniVariant: false
  }),

  methods: {
    getName() {
      var name = ''
      if (this.$store.getters.getLoggedIn) {
        name = this.$store.getters.getName
      }
      return name
    },
    getRole() {
      var role = ''
      if (this.$store.getters.getLoggedIn) {
        if (this.$store.getters.getAdministrator) {
          role = 'Administrator'
        } else if (this.$store.getters.getProShop) {
          role = 'Pro Shop'
        }
      }

      return role
    },
    isLoggedIn() {
      return this.$store.getters.getLoggedIn
    }
  }
}
</script>
